/**
 * The SPA is served under /app (BrowserRouter basename). Links that leave the app
 * (copied share links, emails) must include it, or the router renders nothing.
 */
export const APP_BASENAME = '/app';

/** Absolute URL to an in-app route, e.g. appUrl('/in/link/abc') → https://dev.theyemma.com/app/in/link/abc */
export function appUrl(path: string): string {
  return `${window.location.origin}${APP_BASENAME}${path.startsWith('/') ? path : `/${path}`}`;
}
